import {PolIcon} from "components/PolIcon/policon";
import React from 'react';
import {createPortal} from "react-dom";
import useFixedPosition from "v4/hooks/useFixedPosition";
import useToggle from "v4/hooks/useToggle";

export default function ConfiguredActionsGroup({actions, renderAction, classNamePrefix, btnClassName}) {
    const [isActive, toggleActive] = useToggle();
    const {anchorRef, floatingRef, floatingStyle} = useFixedPosition(isActive, {anchorInline: 'right'});

    const handleGroupClick = (e) => {
        if (e.target.closest('.no-group-click')) return;

        toggleActive();
    }

    const handleMouseLeave = (e) => {
        if (anchorRef.current?.contains(e.relatedTarget) || floatingRef.current?.contains(e.relatedTarget)) return;

        toggleActive(false);
    }

    return (
        <div ref={anchorRef}
             className={`${btnClassName} ${classNamePrefix}__group ${isActive ? 'active' : ''}`}
             onClick={handleGroupClick}
             onMouseLeave={isActive ? handleMouseLeave : undefined}>
            <PolIcon icon="actions"/>
            {createPortal(
                <ul className={`${classNamePrefix}__group__list ${isActive ? 'is-open' : ''}`}
                    ref={floatingRef}
                    style={floatingStyle}
                    onMouseLeave={isActive ? handleMouseLeave : undefined}>
                    {actions.map(renderAction)}
                </ul>,
                document.body)}
        </div>
    )
}
